import { Modal, ModalBody } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import moment from "moment";
import "moment/locale/ru";

import styles from "./ScheduleModal.module.css";

export const ScheduleModal = ({
  data,
  showModal,
  setShowModal,
  student,
  colorOfbutton,
}) => {
  const location = useLocation();
  const isForming = location.pathname === "/schedule/forming/";
  if (data)
    return (
      <Modal onHide={() => setShowModal(false)} show={showModal} centered>
        <ModalBody>
          <button
            type="button"
            className="close"
            onClick={() => setShowModal(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div
            style={{ backgroundColor: colorOfbutton() }}
            className={styles.modalTopLine}
          ></div>
          <div className="p-4">
            <div className="row mx-auto mb-4">
              <div
                className={[
                  "col-12 col-sm-7 mb-4 mb-sm-0",
                  styles.modalContent,
                ].join(" ")}
              >
                <h1 className="m-0">{data.course.name_first}</h1>
                {data.course.name_second && (
                  <span className="d-block">{data.course.name_second}</span>
                )}
                {!isForming && !student && (
                  <span className="d-block">занятие № {data.number}</span>
                )}
                {data.course.module.slug && (
                  <a
                    href={`/module/${data.course.module.slug}`}
                    className={styles.modalLink}
                  >
                    Модуль: {data.course.module.name}
                  </a>
                )}
              </div>
              <div
                className={["col-12 col-sm-5", styles.modalContent].join(" ")}
              >
                <div className="d-flex mb-2">
                  <div className={styles.timeIcon}>
                    <i className="fa fa-clock-o" />
                  </div>
                  <div>
                    <span className={styles.boldText}>{data.time}</span>
                    <span className="d-block text-center">
                      ({data.duration} минут)
                    </span>
                  </div>
                </div>
                {data.room && (
                  <div>
                    <span className="d-block">
                      {moment(data.date).format("D MMMM")}
                    </span>
                    <i className="fa fa-map-marker mr-1"></i>
                    <span>кабинет {data.room}</span>
                  </div>
                )}
              </div>
            </div>
            <div className="row mx-auto">
              <div className={["col-12", styles.modalContent].join(" ")}>
                {(isForming || data.type === "forming") && (
                  <div className="d-flex flex-wrap mb-2">
                    <div className="mr-1">
                      Всего мест:{" "}
                      <span className={styles.boldText}>
                        {data.course.max_students}
                      </span>
                      ,
                    </div>
                    <div className="mr-1">
                      занято:{" "}
                      <span className={styles.boldText}>{data.taken}</span>,
                    </div>
                    <div className="mr-1">
                      осталось:{" "}
                      <span className={styles.boldText}>
                        {data.course.max_students - data.taken}
                      </span>
                    </div>
                  </div>
                )}
                {data.theme && (
                  <div className="mb-2">
                    <h2 className="m-0">{data.theme}</h2>
                    <span>тема</span>
                  </div>
                )}
                {data.teacher && (
                  <div className="mb-2">
                    <h2 className="m-0">{data.teacher}</h2>
                    <span>преподаватель</span>
                  </div>
                )}
                {data.student && (
                  <div className="mb-2">
                    <h2 className="m-0">{data.student}</h2>
                    <span>ученик</span>
                  </div>
                )}
                {data.type === "adaptation" && (
                  <div className="mb-2">
                    <h2 className="m-0">Адаптация</h2>
                  </div>
                )}
                {data.type === "compensation" && (
                  <div className="mb-2">
                    <h2 className="m-0">Компенсация</h2>
                  </div>
                )}
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
};
